import classNames from 'classnames';
import styles from './index.module.css';

interface Props {
  label: React.ReactNode;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  className?: string;
  checked?: boolean;
  disableLabelClick?: boolean;
}

export function CheckBox(props: Props) {
  const {
    label,
    saveFieldValue,
    updateFieldValue,
    className,
    checked,
    disableLabelClick,
  } = props;

  const id = `boolean-checkbox-${label}`;
  return (
    <div className={classNames(className, styles.CheckBox)}>
      <div>
        <input
          id={id}
          checked={checked}
          className={styles.CheckBoxInput}
          onChange={(event: React.FormEvent<HTMLInputElement>) => {
            updateFieldValue(event.currentTarget.checked.toString());
            saveFieldValue(event.currentTarget.checked.toString());
          }}
          type="checkbox"
        />
      </div>
      <label
        className={styles.CheckBoxLabel}
        htmlFor={disableLabelClick ? '' : id}
      >
        {label}
      </label>
    </div>
  );
}
